<span class="ml-1 text-sm vertical-align-top" *ngIf="iconClass()">
  <i [ngClass]="$any(iconClass())" [pTooltip]="tooltip()"></i>
</span>
